import {
  UPLOAD_FAIL,
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  UPLOAD_RESET,
} from "../Constants/UploadConstants";

// CREATE UPLOAD
export const docUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case UPLOAD_REQUEST:
      return { loading: true };
    case UPLOAD_SUCCESS:
      return { loading: false, success: true, itemUrl: action.payload };
    case UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};
